/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';

import { roundTo } from '../../../../../../../helpers/helpers';
import capitalize from '../../../../../../../helpers/capitalize';
import convertPermalinkToPath from '../../../../../../../helpers/urlHelpers';
import { UKDisableMessage } from '../../../../../../../data/ukPrivateCompanyInsights';

import ConditionalTooltip from '../../../../../../UKPrivateCompanyInsights/CommonComponent/ConditionalTooltip';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

const TableSection = (props) => {
  const {
    currentPage, pageSize, currentData, hasInsightsAccess, hasInsightsTrialAccess,
    sortField, sortOrder, onSort,
  } = props;

  const currentYear = moment().format('YYYY');
  const disableMessage = UKDisableMessage(true);

  return (
    <div className={Styles['change-investors-table-holder']}>
      <table className={cx('change-investors-table', { no_access: !hasInsightsAccess })}>
        <thead className={Styles['change-investors-table-header']}>
          <tr className={Styles['change-investors-table-header-row']}>
            <th className={cx('change-investors-table-header-cell', 'rowNumber')}>#</th>
            <th className={cx('change-investors-table-header-cell', 'investorName')}>Investor’s Name</th>
            <th className={cx('change-investors-table-header-cell', 'classOfShare')}>Class of Shares</th>
            {currentData.currentYearHeader.map((year, i) => (
              <th
                key={year}
                className={cx('change-investors-table-header-cell', 'year')}
                colSpan={currentData.currentYearHeader.length !== i + 1 ? 2 : 1}
              >
                {year}
                {year === currentYear ? ' YTD' : ''}
              </th>
            ))}
          </tr>
          <tr className={Styles['change-investors-table-header-row']}>
            <th className={cx('change-investors-table-header-cell', 'rowNumber')} />
            <th className={cx('change-investors-table-header-cell', 'investorName')} />
            <th className={cx('change-investors-table-header-cell', 'classOfShare')} />
            {currentData.currentYearHeader.map((year, i) => (
              <>
                <th
                  className={cx('change-investors-table-header-cell', 'numberOfShares', { highLight: i % 2 === 0 })}
                  key={`${year}_numberOfShares_${i}`}
                >
                  {i === 0 ? (
                    <div className={Styles['table-sorting']} onClick={() => onSort(`year_${year}_numberOfShares`)}>
                      <div>
                        Shares
                      </div>
                      <ConditionalTooltip
                        tooltipProps={{
                          hasBigScreenDesign: true,
                          isCentered: true,
                          dynamicPosition: true,
                          contentStyle: { left: 0 },
                          className: Styles['change-investors-table-tooltip'],
                        }}
                        tooltipMessage={disableMessage}
                        showTooltip={hasInsightsTrialAccess}
                      >
                        <div className={cx('sort-arrows')}>
                          {(sortField !== `year_${year}_numberOfShares` || sortOrder === 'asc') && (
                            <FontAwesomeIcon icon={faCaretUp} className={cx('asc')} />
                          )}
                          {(sortField !== `year_${year}_numberOfShares` || sortOrder === 'desc') && (
                            <FontAwesomeIcon icon={faCaretDown} className={cx('desc')} />
                          )}
                        </div>
                      </ConditionalTooltip>
                    </div>
                  ) : (
                    <>
                      Shares
                    </>
                  )}
                </th>
                {currentData.currentYearHeader.length !== i + 1 && (
                  <th
                    className={cx('change-investors-table-header-cell', 'annualPercentageChangeInNumberOfShares', { highLight: i % 2 === 0 })}
                    key={`${year}_annualPercentageChangeInNumberOfShares_${i}`}
                  >
                    {i === 0 ? (
                      <div className={Styles['table-sorting']} onClick={() => onSort(`year_${year}_annualPercentageChangeInNumberOfShares`)}>
                        <div>
                          Change
                        </div>
                        <ConditionalTooltip
                          tooltipProps={{
                            hasBigScreenDesign: true,
                            isCentered: true,
                            dynamicPosition: true,
                            contentStyle: { left: 0 },
                            className: Styles['change-investors-table-tooltip'],
                          }}
                          tooltipMessage={disableMessage}
                          showTooltip={hasInsightsTrialAccess}
                        >
                          <div className={cx('sort-arrows')}>
                            {(sortField !== `year_${year}_annualPercentageChangeInNumberOfShares` || sortOrder === 'asc') && (
                              <FontAwesomeIcon icon={faCaretUp} className={cx('asc')} />
                            )}
                            {(sortField !== `year_${year}_annualPercentageChangeInNumberOfShares` || sortOrder === 'desc') && (
                              <FontAwesomeIcon icon={faCaretDown} className={cx('desc')} />
                            )}
                          </div>
                        </ConditionalTooltip>
                      </div>
                    ) : (
                      <>
                        Change
                      </>
                    )}
                  </th>
                )}
              </>
            ))}
          </tr>
        </thead>
        <tbody className={Styles['change-investors-table-body']}>
          {!hasInsightsAccess && (
            <tr className={Styles['change-investors-access']}>
              <td
                colSpan={
                  (currentData.currentYearHeader.length > 1 ? 3 : 2)
                  + (currentData.currentYearHeader.length * 2)
                    + (currentData.currentYearHeader.length > 1 ? 0 : 1)
                    + (currentData.currentYearHeader.length ? -1 : 0)
                }
                className={Styles['change-investors-access-cell']}
              >
                <div className={Styles['change-investors-access-body']}>
                  <div className={Styles['change-investors-access-message']}>
                    <Link to="/pricing">Upgrade to UK Insights</Link>
                    {' '}
                    to use this feature.
                  </div>
                </div>
              </td>
            </tr>
          )}
          {currentData.data
            .slice(((currentPage - 1) * pageSize), (((currentPage - 1) * pageSize) + pageSize))
            .map((obj, i) => (
              <tr
                key={i}
                className={Styles['change-investors-table-body-row']}
              >
                <td className={cx('change-investors-table-body-cell', 'rowNumber')}>
                  {((currentPage - 1) * pageSize) + (i + 1)}
                </td>
                <td className={cx('change-investors-table-body-cell', 'investorName')}>
                  {obj.investorPermalink ? (
                    <Link to={convertPermalinkToPath(obj.investorPermalink)}>
                      {obj.investorName || '-'}
                    </Link>
                  ) : (
                    <>
                      {obj.investorName || '-'}
                    </>
                  )}
                </td>
                <td className={cx('change-investors-table-body-cell', 'classOfShare')}>
                  {capitalize(obj.classOfShares || '')}
                </td>
                {currentData.currentYearHeader.map((year, j) => (
                  <>
                    <td
                      className={cx('change-investors-table-body-cell', 'numberOfShares', { highLight: j % 2 === 0 })}
                      key={`${year}_numberOfShares_2_${j}_${i}`}
                    >
                      {(obj[`year_${year}_numberOfShares`] || '').toLocaleString() || '-'}
                    </td>
                    {currentData.currentYearHeader.length !== j + 1 && (
                      <td
                        className={cx('change-investors-table-body-cell', 'annualPercentageChangeInNumberOfShares', { highLight: j % 2 === 0 })}
                        key={`${year}_annualPercentageChangeInNumberOfShares_2_${j}_${i}`}
                      >
                        {typeof obj[`year_${year}_annualPercentageChangeInNumberOfShares`] === 'number'
                          ? `${roundTo(obj[`year_${year}_annualPercentageChangeInNumberOfShares`], 2)}%` : '-'}
                      </td>
                    )}
                  </>
                ))}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableSection;
